import { defineStore } from 'pinia';
import type { CuratedEvent } from '~/types/curated-events';

export const useCuratedEventsStore = defineStore('curatedEvents', () => {
  const events = ref<CuratedEvent[]>([]);
  const selectedDate = ref<string>('');
  const availableDates = ref<string[]>([]);
  const loading = ref<boolean>(false);
  const error = ref<string | null>(null);
  const fetched = ref<boolean>(false);

  const hasEvents = computed(() => events.value.length > 0);

  function setEvents(data: CuratedEvent[]) {
    events.value = data;
    fetched.value = true;
  }

  function setSelectedDate(date: string) {
    selectedDate.value = date;
  }

  function setAvailableDates(dates: string[]) {
    availableDates.value = dates;
  }

  function reset() {
    events.value = [];
    selectedDate.value = '';
    availableDates.value = [];
    loading.value = false;
    error.value = null;
    fetched.value = false;
  }

  return {
    events,
    selectedDate,
    availableDates,
    loading,
    error,
    fetched,
    hasEvents,
    setEvents,
    setSelectedDate,
    setAvailableDates,
    reset,
  };
});
